import { CreditCard } from 'lucide-react'
import type { ReactNode } from 'react'
import { Badge } from '@/components/design-system'
import { EMPTY } from '@/frontend/pages/CommandCenter/Organizations/components/organizationFormatting'
import type {
  OrganizationDetail,
  StripeSummary,
} from '@/frontend/pages/CommandCenter/Organizations/components/organizationDetailTypes'
import {
  FLEET_MACHINE_CONTROL_MODE_LABELS,
  FLEET_MACHINE_ENVIRONMENT_LABELS,
  FLEET_MACHINE_PROVIDER_LABELS,
  type FleetMachineSummary,
} from '@/frontend/types/fleetMachine'

function Metric({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="rounded-lg border border-border bg-card p-4">
      <div className="text-xs font-medium uppercase text-muted-foreground">{label}</div>
      <div className="mt-2 break-all font-mono text-sm text-foreground">{value || EMPTY}</div>
    </div>
  )
}

function MachineSummary({ machine }: { machine: FleetMachineSummary | null }) {
  if (!machine) return <span className="text-muted-foreground">{EMPTY}</span>
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="font-medium text-foreground">{machine.name}</span>
      <Badge>{FLEET_MACHINE_PROVIDER_LABELS[machine.provider]}</Badge>
      <Badge>{FLEET_MACHINE_ENVIRONMENT_LABELS[machine.environment]}</Badge>
      <Badge>{FLEET_MACHINE_CONTROL_MODE_LABELS[machine.control_mode]}</Badge>
      {!machine.enabled && <Badge tone="warning">Desabilitada</Badge>}
    </div>
  )
}

interface Props {
  organization: OrganizationDetail
  stripe: StripeSummary
}

export default function StripeSection({ organization, stripe }: Props) {
  return (
    <section className="space-y-3">
      <h3 className="flex items-center gap-2 text-base font-semibold text-foreground">
        <CreditCard className="h-4 w-4" />
        Stripe
      </h3>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
        <Metric label="Customer ID" value={stripe.stripe_customer_id} />
        <Metric label="Assinatura da organização" value={stripe.stripe_worker_subscription_id} />
        <Metric label="Máquina padrão" value={<MachineSummary machine={organization.default_fleet_machine} />} />
        <Metric label="Assinaturas Stripe" value={`${stripe.active_stripe_subscriptions_count}/${stripe.stripe_subscriptions_count} ativas`} />
        <Metric label="Cortesias" value={`${stripe.active_manual_subscriptions_count}/${stripe.manual_subscriptions_count} ativas`} />
        <Metric label="ID da organização" value={organization.id} />
      </div>
    </section>
  )
}
